export const first = array => array[0];

export const last = array => array[array.length - 1];

export const sideToProperty = side => [side + 'Start', side + 'Lines'];
